import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {Response} from '@angular/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {Candidature} from './candidature.model';
import {CandidatureFormationService} from './candidature-formation.service';
import {CandidatureFormation} from './candidature-formation.model';
import {SelectItem} from 'primeng/primeng';

import {CONSTANTS} from '../../cadens.constants';
import {
    ExportService,
    IKeyedCollection,
    JhiAlertComponent,
    KeyedCollection,
    Principal,
    UserService
} from '../../shared';
import {ListeChoixService} from '../../shared/ListeChoix/listeChoix.service';
import {LocalStorageService} from 'ng2-webstorage';
import {GrhumService, Pays} from '../grhum';
import {Formation, FormationService} from '../formation';
import {DataTable} from 'primeng/components/datatable/datatable';

import {Commission, CommissionService} from '../commission';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';
import {ReponseService} from './formation/reponse.service';
import {EntityVerification} from './entity-verification.model';
import {ListeChoix} from '../../shared/ListeChoix/listeChoix.model';
import {TypeEtudiantEnumeration, UserEnEchange, UserEnEchangeService} from '../user-en-echange';
import {PageScrollInstance, PageScrollService} from 'ng2-page-scroll';
import {DOCUMENT} from '@angular/platform-browser';
import {EnscolService} from './enscol/enscol.service';
import {Inscription} from "./enscol/inscription.model";
import {JsUtil} from '../../shared/util/jsUtil';
import {AdmisService} from '../admis/admis.service';

@Component({
    selector: 'jhi-candidature',
    templateUrl: './candidature.component.html'
})
export class CandidatureComponent implements OnInit, AfterViewInit {
    candidatures: CandidatureFormation[];
    selectedCandidatures: CandidatureFormation[];
    selectedColumns: string[] = ['id', 'libelle', 'civilite', 'candidat', 'statut'];
    searchText = null;
    rowPerPage = 20;
    filters: any;

    paysListe: Pays[];
    currentAccount: any;
    isOnlyEnseignantDelegate = false;
    isResponsableFormation = false;
    isOnlyResponsableFormation = false;
    isAdminOrGestionnaire = false;
    isGestionnaire = false;
    reinscription = false;
    constants = CONSTANTS;
    isLoading = false;
    isVerifying = false;
    displayVerifyingDialog = false;
    valideCandidatureCount: number;
    invalideCandidatureList: EntityVerification[] = [];
    messageErreur = null;
    private backToId: Number;

    @ViewChild('table') dataTable: DataTable;
    @ViewChild('searchFilter') searchFilter: ElementRef;

    // Show / Hide selected columns
    cols: SelectItem[] = [
        {label: 'id', value: 'id'},
        {label: 'statut', value: 'statut'},
        {label: 'formation', value: 'libelle'},
        {label: 'civilité', value: 'civilite'},
        {label: 'nom prénom', value: 'candidat'},
        {label: 'avis', value: 'avis'},
        {label: 'rang comm péda', value: 'avisRang'},
        {label: 'Validation de l avis pédagogique', value: 'response'},
        {label: 'Rang liste complémentaire', value: 'responseRang'},
        {label: 'conforme', value: 'conforme'},
        {label: 'bourse CROUS', value: 'bourse'},
        {label: 'échelon de bourse', value: 'echelon'},
        {label: 'Demande bourse Excellence', value: 'indicBourseExcellence'},
        {label: 'Bénéficiaire bourse Excellence', value: 'bourseExcellence'},
        {label: 'date de création', value: 'dateCreation'},
        {label: 'date de transmission', value: 'dateValidation'},
        {label: 'date de confirmation', value: 'dateConfirmation'},
        {label: 'date de désistement', value: 'dateDesistement'},
        {label: 'date de naissance', value: 'dateNaissance'},
        {label: 'statut ENSCOL', value: 'statutEnscol'},
        {label: 'inscriptions ENSCOL', value: 'inscriptionsEnscol'},
        {label: 'nationalité', value: 'paysNationalite'},
        {label: 'type nationalité', value: 'typeNationalite'},
        {label: 'téléphone', value: 'telephoneFixe'},
        {label: 'email', value: 'email'},
        {label: 'type de formation', value: 'categorieFormation'},
        {label: 'dernier cursus', value: 'dernierCursus'},
        {label: 'niveau études', value: 'niveauEtudes'},
        {label: 'questions complémentaires condensées', value: 'questionsComplementaires'},
        {label: 'questions complémentaires par colonne', value: 'questionsComplementairesParColonne'},
        {label: 'formation continue', value: 'formationContinue'},
        {label: 'commission', value: 'commission'},
        {label: 'voeux', value: 'ordre'},
        {label: 'ei', value: 'ei'},
        {label: 'discipline majeure', value: 'reponseMajorDiscipline'},
        {label: 'université origine', value: 'universiteOrigine'},
        {label: 'pays origine', value: 'paysOrigine'},
        {label: 'type échange', value: 'typeEchange'},
        {label: 'controle identité', value: 'controleIdentiteAdmis'},
        {label: 'old id', value: 'oldCfId'},
    ];

    // Show / Hide selected columns
    colFieldNameDictionary: IKeyedCollection<String> = new KeyedCollection<String>();

    // Actions groupées
    resultatSelected: any;
    avisSelected: any;
    avisRang: number;
    avisCommentaire: any;
    actions: SelectItem[] = [];
    selectedAction = [];
    responseDialog = false;
    avisDialog = false;
    listeCommentaires: ListeChoix[];
    //listeEchelons: ListeChoix[];
    toutesLesCommissions: Commission[];


    libelleList = [];
    mentionList = [];
    parcoursList = [];
    disciplineList = [];
    commissionList = [];
    statutList = [];
    responseList = [];
    avisList = [];
    conformeList = [];
    typeEIList = [];
    disciplineMajeureList = [];
    statutEnscolList = [];
    reponsesQuestionLoaded: boolean = false;
    disciplineMajeurLoaded: boolean = false;
    private subscription: any;

    // pour le split des questions/reponses
    private allQuestions: string[] = [];

    constructor(private jhiLanguageService: JhiLanguageService,
                private candidatureFormationService: CandidatureFormationService,
                private grhumService: GrhumService,
                private formationService: FormationService,
                private reponseService: ReponseService,
                private commissionService: CommissionService,
                private alertService: AlertService,
                private listeChoixService: ListeChoixService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private exportService: ExportService,
                private principal: Principal,
                private localStorage: LocalStorageService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService,
                private userEnEchangeService: UserEnEchangeService,
                private pageScrollService: PageScrollService,
                private userService: UserService,
                private enscolService: EnscolService,
                private admisService: AdmisService,
                @Inject(DOCUMENT) private document: any
    ) {
        this.jhiLanguageService.setLocations(['candidature', 'global']);
        this.colFieldNameDictionary.Add('formationContinue', 'fc');
        this.colFieldNameDictionary.Add('grade', 'formation.libelleGrade');
        this.colFieldNameDictionary.Add('mention', 'formation.libelleMention');
        this.colFieldNameDictionary.Add('parcours', 'formation.libelleParcours');
        this.colFieldNameDictionary.Add('parcours', 'formation.libelleParcours');
        this.colFieldNameDictionary.Add('universiteOrigine', 'userEnEchange.nomUniversiteOrigine');
        this.colFieldNameDictionary.Add('paysOrigine', 'userEnEchange.paysUniversite');
        this.colFieldNameDictionary.Add('typeEchange', 'userEnEchange.typeEchange');
        this.colFieldNameDictionary.Add('niveauEtudes', 'niveauAccessDiplomeLibelle');
        this.colFieldNameDictionary.Add('inscriptionsEnscol', 'inscriptionsEnscolString');
    }

    ngOnInit() {
        this.subscription = this.activatedRoute.params.subscribe(params => {
            this.backToId = params['id'];
        });
        this.isLoading = true;
        this.reinscription = this.activatedRoute.snapshot.data['reinscription'];
        this.resetLastFilters();

        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.initBooleensPermissions(account);
            this.initActionsGroupees();
            this.loadListes();
        });

        // rajout filtre custom pour filter les valeurs non null
        this.dataTable.filterConstraints['notNull'] = (value, filter: any): boolean => {
            if (filter == true) {
                if (value === null) {
                    return false;
                }
            }
            return true;
        }
    }

    private initBooleensPermissions(account) {
        this.isAdminOrGestionnaire = Principal.isAdminOrGestionnaire(account.authorities);
        this.isGestionnaire = Principal.isGestionnaire(account.authorities);
        this.isResponsableFormation = Principal.isResponsableFormation(account.authorities);
        this.isOnlyResponsableFormation = Principal.isOnlyResponsableFormation(account.authorities);
        this.isOnlyEnseignantDelegate = Principal.isOnlyEnseignant(account.authorities);
    }

    private initActionsGroupees() {
        if (this.isGestionnaire || this.isResponsableFormation) {
            this.actions.push({label: 'Avis pédagogique', value: 'avis'});
        }
        if (this.isAdminOrGestionnaire) {
            // Les gestionnaire de formation et référents ne peuvent pas mettre de résultat
            this.actions.push({label: 'Décision admission', value: 'resultat'});
        }
        if (!this.isOnlyEnseignantDelegate) {
            this.actions.push({label: 'Traiter', value: 'traiter'});
        }
        this.actions.push({label: 'Export PDF des sélections', value: 'export'});
        this.actions.push({label: 'Export PDF pour rentree', value: 'exportRentree'});
        if (this.isAdminOrGestionnaire) {
            this.actions.push({label: 'Vérifier candidature', value: 'verifier'});
            this.actions.push({label: "Contrôle pièce d'identité", value: 'controleID'});
        }
    }

    loadAll() {
        // Charger les listes des filtres et des candidatures
        this.candidatureFormationService.query(
            {
                referentId: (this.isOnlyResponsableFormation ? this.currentAccount.id : null),
                enseignantId: (this.isOnlyEnseignantDelegate ? this.currentAccount.id : null),
                reinscription: this.reinscription,
                dateSuppression: this.getFilterProperty('dateSuppression').value
            }).subscribe(
            (res: Response) => {
                this.candidatures = res.json();
                this.isLoading = false;
                if (this.candidatures != null) {
                    if (this.isAdminOrGestionnaire || this.isResponsableFormation || this.isOnlyEnseignantDelegate) {
                        this.candidatures.forEach(candidature => this.loadEnscolData(candidature));
                    }
                    let listeLibelleWithDuplicate: any[];
                    listeLibelleWithDuplicate = this.candidatures.filter(candidature => candidature != null && candidature.libelle != null).map(candidature => ({
                        label: candidature.libelle, value: candidature.libelle
                    })).sort((n1, n2) => n1.label.localeCompare(n2.label));
                    let previousLibelle = null;
                    listeLibelleWithDuplicate.forEach(candidature => {
                        if (previousLibelle == null ||
                            (previousLibelle != candidature.label)) {
                            this.libelleList.push(candidature);
                        }
                        previousLibelle = candidature.label;
                    });
                    this.loadQuestionsComplementaires();
                }
                this.reponseService.findMajorDiscipline().subscribe(results => {
                    results.forEach(reponse => {
                        this.candidatures.filter(candidature => candidature.id == reponse.candidatureFormationId).forEach(candidatureMajor => {
                            candidatureMajor.reponseMajorDiscipline = this.getDisciplineMajeurLibelle(reponse.response);
                        })
                    });
                    this.disciplineMajeurLoaded = true;
                }, (res: Response) => this.onError(res.json()));
                this.grhumService.queryPays().subscribe(
                    (res: Response) => {
                        this.paysListe = res.json();
                        this.userEnEchangeService.query(TypeEtudiantEnumeration.enEchange).subscribe((reponse: Response) => {
                            let listeUserEnEchange: UserEnEchange[] = reponse.json();
                            if (listeUserEnEchange != null) {
                                this.candidatures.filter(candidature => candidature.ei == CONSTANTS.EN_ECHANGE).forEach(candidature => {
                                    candidature.userEnEchange = listeUserEnEchange.find(userenEchange => userenEchange.email == candidature.email);
                                    if (candidature.userEnEchange != null && candidature.userEnEchange.codePaysUniversite != null) {
                                        let pays = this.paysListe.find(pays => pays.code == candidature.userEnEchange.codePaysUniversite);
                                        if (pays != null) {
                                            candidature.userEnEchange.paysUniversite = pays.pays;
                                        }
                                    }
                                }, (res: Response) => this.newOnError(res.json()));
                            }
                        }, (res: Response) => this.newOnError(res.json()));
                    }, (res: Response) => this.newOnError(res.json()));
                if (this.backToId != null) {
                    let backToId = this.backToId;
                    setTimeout(() => {
                        this.scrollToCandidature(backToId)
                    }, 1000)
                }
                setTimeout(() => this.applyFilters(), 100);
            },
            (res: Response) => this.newOnError(res.json())
        );
    }

    loadEnscolData(candidature: CandidatureFormation) {
        if(candidature.persId != undefined) {

            // Récupération du statut ENSCOL

            this.enscolService.getStatut(candidature.persId)
                    .subscribe(statut => {candidature.statutEnscol = statut;},
                            error => this.newOnError(error));

            // Récupération des inscriptions ENSCOL

            this.enscolService.getInscriptions(candidature.persId)
                .subscribe((inscriptions: Inscription[]) => {

                    candidature.inscriptionsEnscol = inscriptions;

                    // Tri des inscriptions pour avoir la principale en premier

                    candidature.inscriptionsEnscol.sort((obj1, obj2) => {
                        if (obj2.typeinscription === 'Principale') {
                            return 1;
                        }
                        return -1;
                    });

                    // Conversion en string pour affichage dans datatable

                    candidature.inscriptionsEnscol.forEach(inscription => {
                        if(candidature.inscriptionsEnscolString !== undefined) {
                            candidature.inscriptionsEnscolString += '\n\n';
                        }
                        else {
                            candidature.inscriptionsEnscolString = '';
                        }
                        candidature.inscriptionsEnscolString +=  inscription.typediplome + ' - ' + inscription.niveau + ' - '
                            + inscription.diplome + ' - ' + inscription.parcours + ' (' +  inscription.typeinscription + ')';
                    });
                },
                error => this.newOnError(error));
        }
    }

    scrollToCandidature(candidatureId: Number) {
        if (candidatureId != null) {
            let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '#' + candidatureId);
            this.pageScrollService.start(pageScrollInstance);
        }
    }

    ngAfterViewInit(): void {
        const translateKey = 'cadensApp.candidature.colonnes';
        const multiSelectId = 'columnSelection';
        this.translateService.get(translateKey).subscribe(translation => {
            JsUtil.setMultiSelectLabel(multiSelectId, translation);
        });
    }

    goToCandidature(candidature: Candidature, enTantQueUser: Boolean) {
        this.saveFilters();
        if (this.reinscription) {
            if (enTantQueUser == true) {
                this.router.navigate(['/reinscription/' + candidature.id + '/' + candidature.userId]);
            } else {
                this.router.navigate(['/reinscription/' + candidature.id]);
            }
        } else {
            if (enTantQueUser == true) {
                this.router.navigate(['/candidature/' + candidature.id + '/' + candidature.userId]);
            } else {
                this.router.navigate(['/candidature/' + candidature.id]);
            }
        }
    }

    getCandidatureLink(candidatureId: Number): String {
        if (this.reinscription) {
            return '/reinscription/' + candidatureId;
        } else {
            return '/candidature/' + candidatureId;
        }
    }

    // Modification du Rang sur la liste complémentaire d'une candidature
    saveRang(candidature: CandidatureFormation) {
        this.candidatureFormationService.update(candidature, false, false).subscribe(res => {
            this.isLoading = true;
            candidature.saved = true;
            this.loadAll();
        }, err => {
            this.newOnError(err);
        });
    }

    onErrorMessage(message: any, params: any) {
        JhiAlertComponent.onErrorMessage(this.alertService, message, params);
    }

    onSuccessMessage(message: any, params: any) {
        JhiAlertComponent.onSuccessMessage(this.alertService, message, params);
    }

    /****************** ACTIONS GROUPEES ******************/

    // Selection d'une action groupée
    onSelectedAction(event) {
        if (this.selectedCandidatures != null && this.selectedCandidatures.length > 0) {
            // Sélectionner le service gérant les formations sélectionnées
            if (this.selectedAction.indexOf('avis') > -1) {
                if (this.verifCandidatureAvantModifAvisPedagogique(this.selectedCandidatures) == true) {
                    this.avisDialog = true;
                }
            }
            if (this.selectedAction.indexOf('resultat') > -1) {
                if (this.verifCandidatureAvantModifReponse(this.selectedCandidatures) == true) {
                    this.responseDialog = true;
                }
            } else if (this.selectedAction.indexOf('traiter') > -1) {
                // Traiter toutes les candidatures les unes après les autres (mets des flèches de navigation)
                let idsList = this.selectedCandidatures.map(candi => candi.id);
                this.router.navigate(['/candidature/' + idsList[0], {
                    listeCandidatures: idsList
                }]);
            } else if (this.selectedAction.indexOf('export') > -1) {
                // Export d'un ZIP regroupant tous les Pdf
                let idsList = this.selectedCandidatures.map(candi => candi.id);
                this.isLoading = true;
                this.candidatureFormationService.generatePDFs(idsList, false, this.candidatureFormationService.exportPdfNormal).subscribe((res) => {
                    this.isLoading = false;
                    ExportService.download(res, 'Candidatures.zip');
                    this.selectedAction = [];
                });
            } else if (this.selectedAction.indexOf('exportRentree') > -1) {
                // Export d'un ZIP regroupant tous les Pdf pour la rentree
                let idsList = this.selectedCandidatures.map(candi => candi.id);
                this.isLoading = true;
                this.candidatureFormationService.generatePDFs(idsList, false, this.candidatureFormationService.exportPdfRentree).subscribe((res) => {
                    this.isLoading = false;
                    ExportService.download(res, 'CandidaturesRentree.zip');
                    this.selectedAction = [];
                });
            } else if (this.selectedAction.indexOf('verifier') > -1) {
                let idsList = this.selectedCandidatures.map(candi => candi.id);
                this.verifierListeCandidature(idsList);
            } else if (this.selectedAction.indexOf('controleID') > -1) {
                this.controlerIdentites(this.selectedCandidatures);
            }
        } else {
            this.selectedAction = [];
        }
    }

    verifierListeCandidature(candidatureFormationIds: number[]) {
        this.valideCandidatureCount = 0;
        this.invalideCandidatureList = [];
        this.loopVerifierListeCandidature(candidatureFormationIds)
    }

    loopVerifierListeCandidature(candidatureFormationIds: number[]) {
        if (candidatureFormationIds != null && candidatureFormationIds.length > 0) {
            this.isVerifying = true;
            this.displayVerifyingDialog = true;
            let candidatureFormationId: number = candidatureFormationIds[0];
            this.candidatureFormationService.verifierCandidature(candidatureFormationId, false).subscribe((verif: EntityVerification) => {
                    if (!verif.verificationOk) {
                        verif.translatedMessage = this.translateService.instant(JhiAlertComponent.construitCleMessage(verif.message, verif.entityName, verif.applicationName));
                        this.invalideCandidatureList.push(verif);
                    } else {
                        this.valideCandidatureCount++;
                    }
                    //this.onSuccessMessage('cadensApp.candidature.error.candidatureValide', {id:candidatureFormationId});
                    //ATTENTION RECURSIF
                    if (this.isVerifying) {
                        this.loopVerifierListeCandidature(candidatureFormationIds.filter(id => id != candidatureFormationId))
                    }
                },
                (res: Response) => {
                    this.isVerifying = false;
                    let verif = new EntityVerification();
                    verif.entityId = candidatureFormationId;
                    verif.message = 'cadensApp.candidature.verification.candidatureInvalide';
                    this.invalideCandidatureList.push(verif);
                    //this.onErrorMessage('cadensApp.candidature.error.candidatureInvalide', {id:candidatureFormationId});
                    this.newOnError(res);
                });
        } else {
            this.isVerifying = false;
            if (this.invalideCandidatureList.length > 0) {
                this.onErrorMessage('cadensApp.candidature.verification.candidatureInvalideCount',
                    {'count': this.invalideCandidatureList.length});
            } else {
                this.onSuccessMessage('cadensApp.candidature.verification.candidatureValideCount',
                    {'count': this.valideCandidatureCount});
            }
        }
    }

    cancelResponse() {
        this.responseDialog = false;
        this.selectedAction = [];
    }

    cancelAvis() {
        this.avisDialog = false;
        this.selectedAction = [];
    }

    cancelDialogInvalideCandidature() {
        this.invalideCandidatureList = [];
        this.displayVerifyingDialog = false;
    }

    saisirAvis(candidatureFormation: CandidatureFormation) {
        this.selectedCandidatures = [candidatureFormation];
        this.selectedAction = ['avis'];
        this.onSelectedAction(null);
    }

    exportCSV(fullExport: Boolean) {
        let colHeaderDictionary: IKeyedCollection<String> = new KeyedCollection<String>();
        this.cols.forEach(col => {
            colHeaderDictionary.Add(col.value, col.label);
        });

        let columns: string[] = this.cols.map(col => col.value);
        if (!columns.find(x => x === 'nom')) {
            columns.push('nom');
            colHeaderDictionary.Add('nom', 'nom');
        }
        if (!columns.find(x => x === 'prenom')) {
            columns.push('prenom');
            colHeaderDictionary.Add('prenom', 'prénom');
        }
        let libelleIndex: number = columns.findIndex(col => col == 'libelle');
        if (libelleIndex == null) {
            libelleIndex = columns.length - 1;
        }
        if (!columns.find(x => x === 'grade')) {
            columns.splice(libelleIndex + 1, 0, 'grade');
            colHeaderDictionary.Add('grade', 'grade');
        }
        if (!columns.find(x => x === 'mention')) {
            columns.splice(libelleIndex + 2, 0, 'mention');
            colHeaderDictionary.Add('mention', 'mention');
        }
        if (!columns.find(x => x === 'parcours')) {
            columns.splice(libelleIndex + 3, 0, 'parcours');
            colHeaderDictionary.Add('parcours', 'parcours');
        }
        libelleIndex = columns.findIndex(col => col == 'dernierCursus');
        if (libelleIndex == null) {
            libelleIndex = columns.length - 1;
        }
        if (!columns.find(x => x === 'questionsComplementaires')) {
            columns.splice(libelleIndex + 1, 0, 'questionsComplementaires');
            colHeaderDictionary.Add('questions complémentaires condensées', 'questionsComplementaires');
        }
        if (!columns.find(x => x === 'questionsComplementairesParColonne')) {
            columns.splice(libelleIndex + 2, 0, 'questionsComplementairesParColonne');
            colHeaderDictionary.Add('questions complémentaires par colonne', 'questionsComplementairesParColonne');
        }

        if (fullExport == false) {
            columns = columns.filter(column => this.selectedColumns.find(selectedCol => selectedCol == column) != null);
        }

        let updatePourExport = [];
        updatePourExport.push(this.formationService.query({userId: this.currentAccount.id}));
        if (this.reponsesQuestionLoaded == false) {
            updatePourExport.push(this.reponseService.getAllReponsesCandidature());
        }
        if (updatePourExport.length > 0) {
            Observable.forkJoin(updatePourExport).subscribe(
                (results: Response[]) => {
                    if (results != null && results.length > 0) {
                        let formationList: Formation[] = results[0].json();
                        formationList.forEach(formation => {
                            this.candidatures.filter(candidature => candidature.formationId == formation.id).forEach(candidatureFormation => {
                                candidatureFormation.formation = formation;
                            })
                        });
                    }
                    if (results != null && results.length > 1) {
                        this.completerCandidatureFormation(results[1].json());
                    }
                    let data = this.dataTable.filteredValue != null ? this.dataTable.filteredValue : this.dataTable.value;

                    // Ajout des colonnes correspondant aux questions complémentaires (lorsqu'un export par colonne est choisi)
                    if (columns.find(x => x === 'questionsComplementairesParColonne')) {
                        let idx = columns.indexOf('questionsComplementairesParColonne');
                        if (idx != -1) {
                            columns.splice(idx, 1, ...this.allQuestions.map(question => ExportService.QUESTION_PREFIX + question));
                            data.forEach((record: any) => {
                                this.allQuestions.forEach(question => {
                                   record[ExportService.QUESTION_PREFIX + question] = ExportService.QUESTION_PREFIX + question;
                                });
                            });
                        }
                    }
                    this.exportService.toCSVAvecNomOrigineField(data, columns, this.colFieldNameDictionary, colHeaderDictionary, 'Candidatures.csv');
                }, (res: Response) => {
                    this.onError(res);
                }
            )
        }

    }

    /****************************************
     *  FILTRES DU TABLEAU DES CANDIDATURES *
     *  *************************************/

    applyFilters() {
        let defaultFilters = this.getDefaultFilters();
        Object.keys(defaultFilters).forEach(filterName => {
                const filterType = Reflect.get(defaultFilters, filterName);
                if (filterType && Object.keys(filterType) && Object.keys(filterType).indexOf('matchMode') > -1) {
                    if (filterName !== 'dateSuppression') {// dateSuppression à part car nécessite de recharger les données depuis le serveur
                        const matchMode = Reflect.get(filterType, 'matchMode');
                        const value = this.getFilterProperty(filterName).value;
                        if(filterName == 'fc'){
                            if(value == false){// si fc cochée alors on affiche les FC et les non FC
                                const valueAll= '';// affiche les FC et FI
                                this.dataTable.filter(valueAll, filterName, matchMode);
                            }else{
                                this.dataTable.filter(value, filterName, matchMode);
                            }
                        }else {
                            this.dataTable.filter(value, filterName, matchMode);
                        }
                    }
                }

        });
    }

    getFilterProperty(propName: string) {
        return this.filters[propName];
    }


    loadListes() {
        let updates = [
            this.listeChoixService.query({type: CONSTANTS.AVIS}),
            this.listeChoixService.query({type: CONSTANTS.ETAT}),
            this.listeChoixService.query({type: CONSTANTS.CONFORME}),
            this.listeChoixService.query({type: CONSTANTS.RESULTAT}),
            this.grhumService.queryComposant({
                type: CONSTANTS.MENTION, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.grhumService.queryComposant({
                type: CONSTANTS.PARCOURS, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.formationService.queryDisciplinesFormations({
                niveau: 1, lecture: true,
                reinscription: this.reinscription ? 1 : 0,
                userId: this.currentAccount.id
            }),
            this.commissionService.query(),
            this.listeChoixService.query({type: CONSTANTS.TYPE_EI}),
            this.listeChoixService.query({type: CONSTANTS.DISCIPLINE_ECH_INT}),
            this.listeChoixService.query({type: CONSTANTS.COMMENTAIRE}),
            this.listeChoixService.query({type: CONSTANTS.STATUT_ENSCOL})
            //this.listeChoixService.query({type: CONSTANTS.ECHELON})
        ];

        Observable.forkJoin(updates).subscribe(results => {
            this.avisList = this.listeChoixService.toLabelValue(results[0].json());
            this.statutList = this.listeChoixService.toLabelValue(results[1].json());
            this.conformeList = this.listeChoixService.toLabelValue(results[2].json());
            this.responseList = this.listeChoixService.toLabelValue(results[3].json());
            this.mentionList = this.grhumService.composantToLabelValue(results[4].json());
            this.parcoursList = this.grhumService.composantToLabelValue(results[5].json());
            this.disciplineList = this.grhumService.disciplineToLabelValue(results[6].json());
            this.commissionList = this.commissionService.toOrderedLabelValue(results[7].json());
            this.toutesLesCommissions = results[7].json();
            this.typeEIList = this.listeChoixService.toLabelValueInteger(results[8].json());
            this.disciplineMajeureList = this.listeChoixService.toLabelValue(results[9].json());
            this.listeCommentaires = this.listeChoixService.toLabelValue(results[10].json());
            this.statutEnscolList = this.listeChoixService.toLabelLabel(results[11].json());
           // this.listeEchelons = this.listeChoixService.toLabelValue(results[12].json());
            this.loadAll();
        }, error => this.newOnError(error));
    }

    // Le filtre sur dateSuppression est fait en rappelant le serveur
    onChangeSuppressionFilter() {
        this.isLoading = true;
        this.loadAll();
    }

    // Récupération des filtres enregistrés sur le Local Storage, ou alors des filtres par défaut
    private getDefaultFilters() {
        return {
            dateSuppression: {matchMode: 'equals', value: true},
            dateValidation: {matchMode: 'notNull', value: !this.isOnlyResponsableFormation},
            fc: {matchMode: 'equals', value: false},
            ei: {matchMode: 'in', value: []},
            avis: {matchMode: 'in', value: []},
            libelle: {matchMode: 'in', value: []},
            mentionId: {matchMode: 'in', value: []},
            parcoursId: {matchMode: 'in', value: []},
            niveauId: {matchMode: 'in', value: []},
            disciplineId: {matchMode: 'in', value: []},
            commissionId: {matchMode: 'in', value: []},
            response: {matchMode: 'in', value: []},
            statut: {matchMode: 'in', value: []},
            statutEnscol: {matchMode: 'in', value: []},
            selectedColumns: ['id', 'libelle', 'civilite', 'candidat', 'statut'],
            sortField: null,
            sortOrder: null,
            searchText: null,
            rowPerPage: 20
        };
    }

    getLocalStorageFilterName() {
        return 'cadensFilters' + (this.reinscription ? 'reinscr' : '');
    }

    // Chargement de toutes les dropdown des filtres de recherche
    resetLastFilters() {
        let lastFilters = this.getDefaultFilters();
        let localFilters = null;
        try {
            localFilters = this.localStorage.retrieve(this.getLocalStorageFilterName());
        } catch (e) {
            this.localStorage.clear(this.getLocalStorageFilterName());
        }
        if (localFilters != null) {
            for (let prop in lastFilters) {
                if (localFilters.hasOwnProperty(prop)) {
                    lastFilters[prop] = localFilters[prop];
                }
            }
            if (localFilters.hasOwnProperty('searchText')) {
                lastFilters['searchText'] = localFilters['searchText'];
            }
            if (localFilters.hasOwnProperty('rowPerPage')) {
                lastFilters['rowPerPage'] = localFilters['rowPerPage'];
            }
            //si il y a des colonnes dans les filtres mémorisés qui n'existent pas dans la liste actuelle on reset les filtres
            if (lastFilters.selectedColumns.filter(selectedColumn =>
                this.cols.filter(col => col.value === selectedColumn).length === 0).length > 0) {
                lastFilters = this.getDefaultFilters();
            }
        }
        this.filters = lastFilters;
        if (this.filters.hasOwnProperty('searchText')) {
            this.searchText = this.getFilterProperty('searchText');
        }
        this.rowPerPage = this.getFilterProperty('rowPerPage');
        this.selectedColumns = this.getFilterProperty('selectedColumns');
    }

    // Enregistrer les filtres de recherche dans le Local Storage
    saveFilters() {
        let filtersToSave: any = {};
        Object.assign(filtersToSave, this.filters);
        filtersToSave.sortField = this.dataTable.sortField;
        filtersToSave.sortOrder = this.dataTable.sortOrder;
        filtersToSave.searchText = this.searchText;
        filtersToSave.rowPerPage = this.dataTable.rows != null ? this.dataTable.rows : 20;
        this.localStorage.clear(this.getLocalStorageFilterName());
        this.localStorage.store(this.getLocalStorageFilterName(), filtersToSave);
    }

    // Bouton Reset RAZ ou pas des filtres de recherche
    resetFilters(raz: boolean) {
        this.isLoading = true;
        let previousDateSupp = this.getFilterProperty('dateSuppression');
        if (raz) {
            this.filters = this.getDefaultFilters();
            this.rowPerPage = this.getFilterProperty('rowPerPage');
            this.selectedColumns = this.getFilterProperty('selectedColumns');
            if (this.filters.hasOwnProperty('searchText')) {
                this.searchText = this.getFilterProperty('searchText');
            }
        } else {
            this.resetLastFilters();
        }
        if (previousDateSupp !== this.getFilterProperty('dateSuppression')) {
            this.loadAll();
        } else {
            this.isLoading = false;
            this.applyFilters();
        }
    }

    onChangeFC(event) {
        this.filters.fc.value = event.target.checked;
        this.applyFilters();
    }

    onChangeDateValidation(event) {
        this.filters.dateValidation.value = event.target.checked;
        this.applyFilters();
    }

    getDisciplineMajeurLibelle(code: string): string {
        if (this.disciplineMajeureList != null && code != null && code.length > 0) {
            let choix = this.disciplineMajeureList.find(choix => choix.value == code);
            if (choix != null) {
                return (choix.label);
            } else {
                return (code);
            }
        }
    }

    // noinspection JSMethodCanBeStatic
    getFilterColor(selecteItems: any): string {
        if (selecteItems != null) {
            if (Array.isArray(selecteItems)) {
                if (selecteItems.length > 0) {
                    return 'orange';
                }
            } else {
                return 'orange';
            }
        }
        return 'black';
    }

    onSelectedColumnsChange($event: any) {
        this.loadQuestionsComplementaires();
    }

    public buildReponseLibelle(reponse): string {
        return ('[' + this.textTruncate(reponse.question.libelle, 50) + '] ' + reponse.response).replace(/<\/?[^>]+(>|$)/g, "").replace(':', "");
    }

    // Nom du filtre sur le Local Storage, est différent sur les 2 pages de candidatures internes / externes

    textTruncate = function (str, length): string {
        if (length == null) {
            length = 100;
        }
        let ending = '...';

        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    verifCandidatureAvantModifReponse(selectedCandidatures: CandidatureFormation[]): boolean {
        let verifOk: boolean = true;

        selectedCandidatures.forEach(candi => {
            if (verifOk) {
                if (candi.statut !== CONSTANTS.FINISHED || candi.dateSuppression !== null) {
                    this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureNonTransmise', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            }
        });
        return verifOk;
    }

    verifCandidatureAvantModifAvisPedagogique(selectedCandidatures: CandidatureFormation[]): boolean {
        let verifOk: boolean = true;
        selectedCandidatures.forEach(candi => {
            if (this.isGestionnaire) {
                if (candi.statut != CONSTANTS.FINISHED &&
                    candi.statut != CONSTANTS.CONFIRMED) {
                    this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureNonTransmise', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            } else {
                if (this.isResponsableFormation) {
                    let dateLimiteAvis = null;
                    if (candi.commissionId != null) {
                        let commission: Commission = this.toutesLesCommissions.find((com: Commission) => com.id == candi.commissionId);
                        if (commission != null) {
                            dateLimiteAvis = commission.dateLimiteAvis;
                        }
                    }
                    if (candi.statut != CONSTANTS.FINISHED ||
                        (candi.statut === CONSTANTS.FINISHED &&
                            candi.avis != null && dateLimiteAvis != null &&
                            dateLimiteAvis < Date.now())
                    ) {
                        this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureDateAvisTardive', {
                            id: candi.id,
                            libelle: candi.libelle == null ? candi.id : candi.libelle,
                            limite: dateLimiteAvis
                        });
                        verifOk = false;
                    }
                } else {
                    this.onErrorMessage('cadensApp.candidature.actionSurCandidature.erreurCandidatureDateAvisDroits', {
                        id: candi.id,
                        libelle: candi.libelle == null ? candi.id : candi.libelle
                    });
                    verifOk = false;
                }
            }
        });
        return verifOk;
    }


    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    private newOnError(response: Response) {
        JhiAlertComponent.onError(this.alertService, response);
    }

    // Popup Modifier Résultat dans Actions groupées
    private saveResponse() {
        this.selectedCandidatures.forEach(candi => {
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.candidature.confirmSave.messagePlusieurs'),
                header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                key: 'actionGroupee',
                accept: () => {
                    this.candidatureFormationService.updateCandidaturesStatus(
                        this.selectedCandidatures, {response: this.resultatSelected}).subscribe(
                        res => {
                            this.responseDialog = false;
                            this.selectedAction = [];
                            this.loadAll();
                        },
                        (res: Response) => {
                            this.newOnError(res);
                            this.responseDialog = false;
                        }
                    )
                },
            });
        });
    }

    // Popup Modifier Avis dans Actions groupées
    private saveAvis() {
        this.selectedCandidatures.forEach(candi => {
            this.confirmationService.confirm({
                message: this.translateService.instant('cadensApp.candidature.confirmSave.messagePlusieurs'),
                header: this.translateService.instant('cadensApp.candidature.confirmSave.title'),
                icon: 'fa fa-check-circle-o',
                key: 'actionGroupee',
                accept: () => {
                    if(this.avisRang !== null && this.avisRang !== undefined && this.avisRang <= 0) {
                        this.alertService.error('cadensApp.candidature.avisRangDoitEtrePositif');
                        this.avisDialog = false;
                    } else {
                        var option: any = {};
                        option.avis = this.avisSelected;
                        if (this.avisSelected == CONSTANTS.AWAITING) {
                            option.avisRang = this.avisRang;
                        } else {
                            if (this.avisSelected == CONSTANTS.NOTFAVORABLE) {
                                option.commentaire = this.avisCommentaire;
                            }
                        }
                        this.candidatureFormationService.updateCandidaturesStatus(
                            this.selectedCandidatures, option).subscribe(
                            res => {
                                this.avisDialog = false;
                                this.selectedAction = [];
                                this.loadAll();
                            },
                            err => {
                                this.newOnError(err);
                                this.avisDialog = false;
                            }
                        );
                    }
                },
            });

        });
    }

    private loadQuestionsComplementaires() {
        if (this.reponsesQuestionLoaded == false && this.selectedColumns.indexOf('questionsComplementaires') > -1) {
            this.reponseService.getAllReponsesCandidature().subscribe(
                (res: Response) => {
                    this.completerCandidatureFormation(res.json());
                },
                (res: Response) => this.newOnError(res))
        }
    }

    private completerCandidatureFormation(reponsesJson: String) {
        if (reponsesJson != null) {
            let reponsesJsonCopy: any = reponsesJson;
            this.allQuestions = [];
            this.candidatures.forEach((candidature: CandidatureFormation) => {
                if (reponsesJsonCopy.hasOwnProperty(candidature.id.toString())) {
                    candidature.reponses = reponsesJsonCopy[candidature.id.toString()];
                    candidature.reponses.forEach(reponse => {
                        if(!this.allQuestions.find(x => x === reponse.question.libelle)){
                            this.allQuestions.push(reponse.question.libelle);
                        }
                    });
                }
            });
            this.reponsesQuestionLoaded = true;
        }
    }

    controlerIdentite(candidatureFormation: CandidatureFormation) {
        this.controlerIdentites([candidatureFormation]);
    }

    controlerIdentites(candidaturesFormation: CandidatureFormation[]) {
        this.admisService.initCandidatures(candidaturesFormation);
        this.router.navigate(['/admis']);
    }

    protected readonly CONSTANTS = CONSTANTS;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature.component.ts